import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const InstagramIconv2 = (props: SvgProps) => (
  <Svg
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeMiterlimit={10}
      d="M16.245 4.38h-7.49A4.375 4.375 0 0 0 4.38 8.756v7.488a4.376 4.376 0 0 0 4.376 4.376h7.488a4.376 4.376 0 0 0 4.376-4.376V8.756a4.375 4.375 0 0 0-4.375-4.376Z"
    />
    <Path
      stroke="#000"
      strokeMiterlimit={10}
      d="M12.5 16.42a3.92 3.92 0 1 0 0-7.84 3.92 3.92 0 0 0 0 7.84Z"
    />
    <Path fill="#000" d="M17.26 8.58a.84.84 0 1 0 0-1.68.84.84 0 0 0 0 1.68Z" />
  </Svg>
)
export default InstagramIconv2
